var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-sheet',{attrs:{"color":"transparent","tile":""}},[_c('v-btn',{attrs:{"color":"primary","to":"/","data-test-selector":"error_actions_back","rounded":"","large":""}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-home")]),_c('span',{domProps:{"textContent":_vm._s(_vm.$t('btn.homePage'))}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }